import { useQuery } from '@tanstack/react-query';
import { lacUserService } from '../../../services/LacUserService';
import { lacQueryKeys } from '../lacQueryKeys';

export function useLacUserQuery(
  tenantName: string | undefined,
  userRef: string | undefined,
) {
  return useQuery({
    queryKey: lacQueryKeys.user(tenantName ?? '', userRef ?? ''),
    enabled: Boolean(tenantName && userRef),
    queryFn: () => {
      if (!tenantName || !userRef) {
        throw new Error('Missing tenant or user reference');
      }
      return lacUserService.getUser(tenantName, userRef);
    },
  });
}
